export const DELIVERY_CARD_PARAM_OPTIONS = {
  homeDelivery: {
    code: 'HOME_DELIVERY',
    label: 'Home Delivery',
    desc: 'Picked, packed and delivered with care. Delivery charges apply',
    cta: 'Choose Delivery Slots',
    param: 'home-delivery/address',
    addressParam: 'home-delivery',
    magentoCode: 'flatrate',
  },
  pickupFromStore: {
    code: 'PICKUP_FROM_STORE',
    label: 'Pickup From Store',
    desc: 'Shop online and collect from Foodstories - Ambience Mall store',
    cta: 'Choose Store Pickup Slots',
    param: 'pickup-from-store/address',
    addressParam: 'pickup-from-store',
    magentoCode: 'freeshipping',
  },
};

export const PATHNAMES = {
  DELIVERY_ADDRESS: 'home-delivery',
  PICKUP_ADDRESS: 'pickup-from-store',
  CHECKOUT: 'checkout',
};

export const ADDRESS_BY_PATHNAME = {
  [PATHNAMES.DELIVERY_ADDRESS]: {
    guestTitle: 'Add Delivery Address',
    nextLink: `/checkout/${PATHNAMES.DELIVERY_ADDRESS}`,
    text: 'delivery',
    title: 'Select Delivery Address',
  },
  [PATHNAMES.PICKUP_ADDRESS]: {
    guestTitle: 'Add Billing Address',
    nextLink: `/checkout/${PATHNAMES.PICKUP_ADDRESS}`,
    text: 'pickup',
    title: 'Select Billing Address',
  },
};

export const STEPS = [
  { text: 'Address' },
  { text: 'Details' },
  { text: 'Payment' },
];

export const PICKUP_STEPS = [
  { text: 'Personal Details' },
  { text: 'Details' },
  { text: 'Payment' },
];

export const PICKUP_FROM_STORE_CANCELLATION_POLICY = [
  'Order cancellation is allowed only for 15 mins after order confirmation',
  'Order modification is handled at the store by our representatives.',
  'Please note that packing of perishable items will start only once you are in the store to pick up your order. Please expect a short wait time.',
];
